import Layout from "@/components/Layout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

import { FileText, FileCheck, FileX, AlertTriangle, Crown, CreditCard, FileStack, PackageX } from "lucide-react";

import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import AxiosDB from "@/Config/AxiosDB";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";


export default function Dashboard({ user, onLogout }) {
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    emitidos: 0,
    recibidos: 0,
    total_rechazados: 0,
    pendientes: 0,
  });
  const [suscripcion, setSuscripcion] = useState(null);


  useEffect(() => {
    loadStats();
    loadSuscripcion();

  }, []);




  const loadSuscripcion = async () => {
    try {
      const res = await AxiosDB.get(`${API}/suscripcion`);
      setSuscripcion(res.data);
    } catch (e) {
      console.error("Error loading suscripcion", e);
    }
  };

  const loadStats = async () => {
    try {
      const emitidosRes = await AxiosDB.get(`/dashboard`);

      const data = emitidosRes.data[0];

      console.log(data)
      setStats({
        emitidos: data.total_emitidos,
        recibidos: 0,
        total_rechazados: data.total_rechazados,
        pendientes: data.total_pendientes
      });
    } catch (error) {
      console.error("Error loading stats:", error);
    }
  };

  const statCards = [
    {
      title: "Comprobantes Emitidos",
      value: stats.emitidos,
      icon: FileText,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      testId: "stat-emitidos",
    },
    {
      title: "Comprobantes Recibidos",
      value: stats.recibidos,
      icon: FileCheck,
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      testId: "stat-recibidos",
    },
    {
      title: "Rechazados",
      value: stats.total_rechazados,
      icon: FileX,
      color: "from-red-500 to-red-600",
      bgColor: "bg-red-50",
      testId: "stat-errores",
    },
    {
      title: "Pendientes",
      value: stats.pendientes,
      icon: AlertTriangle,
      color: "from-amber-500 to-amber-600",
      bgColor: "bg-amber-50",
      testId: "stat-pendientes",
    },
  ];

  return (
    <Layout user={user} onLogout={onLogout} title="Dashboard">
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-slate-800 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Bienvenido, {user?.nombre_usuario}
          </h2>
          <p className="text-slate-600">
            Resumen de tus comprobantes fiscales
          </p>
        </div>


        {/* Resumen de Suscripción */}
        {suscripcion && !suscripcion.tiene_suscripcion_activa && (
          <Card className="border-amber-200 bg-amber-50/60 overflow-hidden" data-testid="sin-suscripcion-card">
            <CardContent className="py-6">
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="p-3 bg-amber-100 rounded-xl shrink-0 self-start">
                  <PackageX className="w-7 h-7 text-amber-600" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-amber-900">No cuentas con un paquete activo</h3>
                  <p className="text-sm text-amber-800/90 mt-1">
                    Actualmente no tienes un <strong>paquete de documentos fiscales contratado</strong> o tu suscripción no es válida.
                    Contacta a tu administrador o adquiere un paquete para comenzar a procesar comprobantes.
                  </p>
                </div>
                <Button
                  className="bg-amber-600 hover:bg-amber-700 text-white shrink-0"
                  onClick={() => navigate("/facturacion")}
                  data-testid="ir-facturacion-sin-sub-button"
                >
                  <CreditCard className="w-4 h-4 mr-2" /> Ver Facturación
                </Button>
              </div>
            </CardContent>
          </Card>
        )}

        {suscripcion && suscripcion.tiene_suscripcion_activa && (
          <Card className="border-slate-200 overflow-hidden" data-testid="suscripcion-card">
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4 flex items-center justify-between flex-wrap gap-3">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-white/15 rounded-lg">
                  <Crown className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-xs text-blue-100 uppercase tracking-wide">Suscripción actual</p>
                  <h3 className="text-lg font-bold text-white" data-testid="plan-nombre">{suscripcion.plan_nombre}</h3>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="px-3 py-1 rounded-full bg-green-400/20 text-green-50 text-xs font-semibold border border-green-300/40">
                  {suscripcion.estado === "activa" ? "Activa" : suscripcion.estado}
                </span>
                <Button size="sm" variant="secondary" className="bg-white text-blue-700 hover:bg-blue-50"
                  onClick={() => navigate("/facturacion")} data-testid="ir-facturacion-button">
                  <CreditCard className="w-4 h-4 mr-2" /> Ver Facturación
                </Button>
              </div>
            </div>
            <CardContent className="pt-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                <div className="text-center md:text-left">
                  <p className="text-sm text-slate-500">Documentos Contratados</p>
                  <p className="text-3xl font-bold text-slate-800" data-testid="docs-contratados" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    {suscripcion.documentos_contratados}
                  </p>
                </div>
                <div className="text-center md:text-left">
                  <p className="text-sm text-slate-500">Documentos Procesados</p>
                  <p className="text-3xl font-bold text-blue-600" data-testid="docs-usados" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    {suscripcion.documentos_usados}
                  </p>
                </div>
                <div className="text-center md:text-left">
                  <p className="text-sm text-slate-500">Documentos Disponibles</p>
                  <p className="text-3xl font-bold text-green-600" data-testid="docs-disponibles" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    {suscripcion.documentos_disponibles}
                  </p>
                </div>
              </div>
              <div>
                <div className="flex items-center justify-between text-sm mb-2">
                  <span className="text-slate-600 flex items-center gap-2">
                    <FileStack className="w-4 h-4" /> Uso del plan
                  </span>
                  <span className="font-semibold text-slate-800" data-testid="porcentaje-uso">
                    {suscripcion.documentos_usados} / {suscripcion.documentos_contratados} ({suscripcion.porcentaje_uso}%)
                  </span>
                </div>
                <Progress value={Math.min(suscripcion.porcentaje_uso, 100)} className="h-3" data-testid="uso-progress" />
                <p className="text-xs text-slate-500 mt-2">
                  Renueva el {suscripcion.fecha_renovacion} · {new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' }).format(suscripcion.precio_mensual)}/mes
                </p>
              </div>
            </CardContent>
          </Card>
        )}



        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {statCards.map((stat, index) => (
            <Card key={index} className="card-hover" data-testid={stat.testId}>
              <CardHeader className="pb-3">
                <div className="flex items-center justify-between">
                  <CardDescription className="text-sm font-medium">
                    {stat.title}
                  </CardDescription>
                  <div className={`p-2 rounded-lg ${stat.bgColor}`}>
                    <stat.icon className="w-5 h-5 text-slate-700" />
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  {stat.value}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="glass">
          <CardHeader>
            <CardTitle>Información del Usuario</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-slate-600">RNC</p>
                <p className="text-base font-semibold text-slate-800" data-testid="user-rnc">{user?.rnc}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Usuario</p>
                <p className="text-base font-semibold text-slate-800" data-testid="user-usuario">{user?.usuario}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Correo Electrónico</p>
                <p className="text-base font-semibold text-slate-800" data-testid="user-correo">{user?.correo}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Teléfono</p>
                <p className="text-base font-semibold text-slate-800" data-testid="user-telefono">{user?.telefono}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}